export default {
  name: [
    v => !!v || 'Nazwa jest wymagana',
    v => v.length >= 2 || 'Nazwa musi mieć co najmniej 2 znaków',
    v => v.length <= 24 || 'Nazwa może mieć maksymalnie 24 znaków',
  ],
  color: [
    v => !!v || 'Kolor jest wymagany',
    v => v.length <= 21 || 'Kolor może mieć maksymalnie 21 znaków',
  ],
}